import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col } from "reactstrap";
import moment from "moment";

import litigantMenuActions from "../../actions/litigantMenuActions";
import CancelAppointmentModal from "./CancelAppointmentModal";
import RequestAppointmentModal from "./RequestAppointmentModal";

const LitigantMenu = () => {
  const menuOptions = useSelector(
    (state) => state.litigantMenu.litigantMenuOptions
  );
  const dispatch = useDispatch();
  useEffect(() => {
    //console.log("dispatch on load");
    //console.log(user.id, user.token);
    dispatch(litigantMenuActions.getLitigantMenuOptions());
  }, [dispatch]);
  return (
    <Row>
      <Col style={{ marginTop: "25px" }} xs={12}>
        <h4>LITIGANT RESOURCES</h4>
      </Col>
      <Col style={{ marginTop: "5px" }} xs={12}>
        <Row>
          <Col xs={12}>
            <hr />
          </Col>
          <Col xs={12}>
            <h5>Home</h5>
            <Link to="/user" className="sideBarMenuItem">
              <span>Home</span>
            </Link>
            <br />
          </Col>
          <Col xs={12}>
            <hr />
          </Col>
          <Col xs={12}>
            <h5>Personal Info</h5>
            <Link to="/user/updatePersonalInfo" className="sideBarMenuItem">
              <span>Update personal info</span>
            </Link>
            <br />
            <Link to="/user/updatePassword" className="sideBarMenuItem">
              <span>Update password</span>
            </Link>
          </Col>
          <Col xs={12}>
            <hr />
          </Col>
          <Col xs={12}>
            <h5>Questionnaires</h5>
            {menuOptions && !menuOptions.hasCurrentQuestionnaire && (
              <React.Fragment>
                <Link to="/user/userQuestionnaire" className="sideBarMenuItem">
                  <span>New questionnaire</span>
                </Link>
                <br />
              </React.Fragment>
            )}
            {menuOptions && menuOptions.hasCurrentQuestionnaire && (
              <React.Fragment>
                {!menuOptions.hasAppointment && (
                  <Link
                    to="/user/userQuestionnaire"
                    className="sideBarMenuItem"
                  >
                    <span>Edit questionnaire</span>
                  </Link>
                )}
                {menuOptions.hasAppointment && (
                  <Link
                    to="/user/userQuestionnaire"
                    className="sideBarMenuItem"
                  >
                    <span>View questionnaire</span>
                  </Link>
                )}
                <br />
              </React.Fragment>
            )}
            {menuOptions && menuOptions.HasPreviousQuestionnaires && (
              <React.Fragment>
                <Link to="/user/userQuestionnaire" className="sideBarMenuItem">
                  <span>View previous questionnaires</span>
                </Link>
              </React.Fragment>
            )}
          </Col>
          <Col xs={12}>
            <hr />
          </Col>
          <Col xs={12}>
            <h5>Appointments</h5>
            {menuOptions && menuOptions.hasAppointment && (
              <React.Fragment>
                <span>
                  Scheduled for{" "}
                  {moment(menuOptions.appointmentDate).format(
                    "MMMM Do YYYY, h:mm a"
                  )}
                </span>
                <CancelAppointmentModal />
                <br />
              </React.Fragment>
            )}
            {menuOptions &&
              !menuOptions.hasAppointment &&
              menuOptions.hasCurrentQuestionnaire && (
                <React.Fragment>
                  {menuOptions.hasSubmittedRequestInAWeek && (
                    <span className="text-primary">
                      Your request for an appointment is being processed.
                    </span>
                  )}{" "}
                  {menuOptions &&
                    !menuOptions.hasAppointment &&
                    !menuOptions.hasSubmittedRequestInAWeek && (
                      <RequestAppointmentModal />
                    )}
                  <br />
                </React.Fragment>
              )}
            {menuOptions &&
              !menuOptions.hasAppointment &&
              !menuOptions.hasCurrentQuestionnaire && (
                <React.Fragment>
                  <Link
                    to="/user/userQuestionnaire"
                    className="sideBarMenuItem"
                  >
                    <span>Start by filling out a questionnaire</span>
                  </Link>
                  <br />
                </React.Fragment>
              )}
            {menuOptions && menuOptions.metYearlyLimitOfThree && (
              <React.Fragment>
                <span>Appointment limit met for the year</span>
                <br />
              </React.Fragment>
            )}
            {menuOptions && menuOptions.HasPreviousAppointments && (
              <React.Fragment>
                <span>View previous appointments</span>
              </React.Fragment>
            )}
          </Col>
          <Col xs={12}>
            <hr />
          </Col>
          <Col xs={12}>
            <h5>Sign Out</h5>
            <Link to="/" className="sideBarMenuItem">
              <span>Sign out</span>
            </Link>
            <br />
          </Col>
          <Col xs={12} className="psInfo"></Col>
        </Row>
      </Col>
    </Row>
  );
};

export default LitigantMenu;
